import React, { useEffect, useState } from 'react'
import { Layout, message, Tabs } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt, faVial } from '@fortawesome/free-solid-svg-icons'
import { manualMenuPop } from '../../../../../core/utils/controller'
import CoreEnums from '../../../../../core/utils/enums'
import { readClinicalEntries } from '../../../../Examination/examination-utils/examination-lib'
import { readCareSyncLabTests } from '../../../../Super-Admin/CareSync/LabTests/utils/utils'
import { readClinicDataPoints } from '../../../../Super-Admin/Data Points/data-points-utils/data-point-utils'
import PrevNextFloatingButtons from '../../../Reusable Components/Buttons/PrevNextFloatingButtons'
import { careSyncDataPointsReducer, careSyncTestResultsReducer, careSyncTestsReducer } from '../../utils/reducers'
import '../styling/PatCSMobileWrapper.css'
import careSyncIcon from '../../../../../assets/images/caresync_icon.png'
import CareSyncOverview from './Overview/CareSyncOverview'
import ResultsHistory from './Results/ResultsHistory/ResultsHistory'
import TestMenu from './TestMenu/index'

const PatCSMobileWrapper = () => {
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState('overview')
  const [loading, setLoading] = useState(false)
  const [isViewingDetail, setIsViewingDetail] = useState(false)
  const authState = useSelector((state) => state.auth)

  // Fetch all necessary data on component mount
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      setLoading(true)
      // Fetch lab tests
      const tests = await readCareSyncLabTests()

      // Fetch test results for current user
      const testResults = await readClinicalEntries({
        userRef: authState.agiliteUser._id,
        category: 'poc'
      })

      // Fetch data points for these test results
      const dataPoints = await readClinicDataPoints({
        key: { $in: testResults.map((result) => result.key) }
      })

      // Update Redux store with fetched data
      dispatch(careSyncTestsReducer.actions.setRecords(tests))
      dispatch(careSyncTestResultsReducer.actions.setRecords(testResults))
      dispatch(careSyncDataPointsReducer.actions.setRecords(dataPoints))
    } catch (error) {
      message.error('Failed to load health data')
    } finally {
      setLoading(false)
    }
  }

  // Handle back navigation
  const handleBackNavigation = () => {
    // If viewing a result detail, first go back to the previous screen
    if (isViewingDetail) {
      setIsViewingDetail(false)
      return
    }

    // Otherwise, go back to the health stats screen
    manualMenuPop(CoreEnums.tabKeys.PAT_HEALTH_STATS, dispatch)
  }

  return (
    <div className='cs-mobile-wrapper'>
      <Layout className='cs-mobile-container'>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className='cs-mobile-tabs'
          animated={{ tabPane: true }}
          items={[
            {
              key: 'overview',
              label: (
                <span className='cs-tab-label'>
                  <img src={careSyncIcon} alt='CareSync' className='cs-tab-icon' />
                  <span>Overview</span>
                </span>
              ),
              children: (
                <CareSyncOverview
                  setActiveTab={setActiveTab}
                  isLoading={loading}
                  onViewDetail={() => setIsViewingDetail(true)}
                  onBackFromDetail={() => setIsViewingDetail(false)}
                  isViewingDetail={isViewingDetail}
                />
              )
            },
            {
              key: 'tests',
              label: (
                <span className='cs-tab-label'>
                  <FontAwesomeIcon icon={faVial} />
                  <span>Tests</span>
                </span>
              ),
              children: <TestMenu onBack={() => setActiveTab('overview')} />
            },
            {
              key: 'results',
              label: (
                <span className='cs-tab-label'>
                  <FontAwesomeIcon icon={faFileAlt} />
                  <span>Results</span>
                </span>
              ),
              children: (
                <ResultsHistory
                  onViewDetail={() => setIsViewingDetail(true)}
                  onBackFromDetail={() => setIsViewingDetail(false)}
                  isViewingDetail={isViewingDetail}
                />
              )
            }
          ]}
        />
      </Layout>

      {/* Back navigation button */}
      <PrevNextFloatingButtons prevOnly onPrev={handleBackNavigation} prevText='Back' />
    </div>
  )
}

export default PatCSMobileWrapper
